import { createBuilder } from "@ibnlanre/builder";
import { http } from "./http";

export const builder = createBuilder(http, {
  prefix: ["idss", "pro"],
});
